import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bs-pagination" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "lucide lucide-chevrons-left h-4 w-4"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m11 17-5-5 5-5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m18 17-5-5 5-5" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "lucide lucide-chevron-left h-4 w-4"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m15 18-6-6 6-6" })
], -1)
const _hoisted_4 = { class: "bs-pagination__controls" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "lucide lucide-chevron-right h-4 w-4"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m9 18 6-6-6-6" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "lucide lucide-chevrons-right h-4 w-4"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m6 17 5-5-5-5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m13 17 5-5-5-5" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_icon_button = _resolveComponent("bs-icon-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_bs_icon_button, {
      disabled: _ctx.modelValue === 1 || _ctx.disabled,
      onClick: _ctx.onFirstPage
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    _createVNode(_component_bs_icon_button, {
      disabled: _ctx.modelValue === 1 || _ctx.disabled,
      onClick: _ctx.onPreviousPage
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controlsCount, (page, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["controls__control", {
                    'control--disabled': _ctx.disabled,
                    'control--selected': _ctx.modelValue === page
                }]),
          key: `control-${i}`,
          onClick: ($event: any) => (_ctx.onChangePage(page))
        }, _toDisplayString(page), 11, _hoisted_5))
      }), 128))
    ]),
    _createVNode(_component_bs_icon_button, {
      disabled: _ctx.modelValue >= _ctx.totalPages || _ctx.disabled,
      onClick: _ctx.onNextPage
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    _createVNode(_component_bs_icon_button, {
      disabled: _ctx.modelValue >= _ctx.totalPages || _ctx.disabled,
      onClick: _ctx.onLastPage
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }, 8, ["disabled", "onClick"])
  ]))
}